var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 900.000000 900.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,900.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#776e03",
    d: "M3780 7250 c-767 -28 -1964 -122 -2260 -176 -174 -32 -342 -118 -470 -240 -183 -175 -258 -322 -320 -623 -36 -179 -64 -391 -87 -661 -15 -175 -18 -328 -18 -1040 0 -845 4 -982 41 -1310 20 -175 59 -410 89 -532 87 -355 354 -634 695 -727 173 -47 1423 -156 2025 -176 99 -4 194 -8 210 -11 59 -9 1305 -12 1530 -4 635 24 1215 64 1880 131 165 16 338 37 384 45 198 36 364 127 517 286 185 190 260 394 324 878 47 357 52 494 55 1315 2 429 -1 859 -6 955 -24 472 -92 924 -168 1113 -112 280 -350 499 -632 580 -179 53 -1388 160 -2044 182 -99 4 -193 8 -210 11 -58 9 -1313 12 -1535 4z m170 -1563 c30 -13 188 -95 350 -183 162 -88 578 -313 925 -499 676 -365 716 -391 730 -469 12 -63 -2 -104 -54 -155 -37 -36 -157 -105 -556 -320 -281 -151 -697 -376 -925 -500 -228 -124 -442 -236 -474 -249 -110 -45 -210 -12 -257 85 l-24 48 -3 1025 c-2 697 1 1041 8 1075 30 140 144 198 280 142z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.781afbdacb3eba603ce1c867a26cc81d.svg";
export { ForwardRef as ReactComponent };